import { TheMask } from 'vue-the-mask'

export default {
  name: 'CollaborationPhone',
  components: {
    TheMask,
  },
  props: {
    value: String,
    error: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'tel',
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  data() {
    return {
      inputValue: '',
    }
  },
  watch: {
  },
  computed: {
    phoneMask() {
      return '+380 (##) ###-##-##'
    },
  },
  methods: {
    updateValue(value) {
      this.inputValue = '380' + value
      this.$emit('input', '380' + value)
    },
    reset() {
      this.$refs.phoneInput.display = '';
      this.inputValue = "";
    }
  },
}
